module.exports = "pegasus_template/assets/pexels-logo.png";